const fractions = {
  label: 3,
  value: 6,
  trend: 3,
  sparkline: 8,
};

export interface SingleValueComponent {
  label: string;
  value: string;
  trend: string;
  sparkline: string;
  content: string;
}

export const sumFractions = (configWithFractions: Array<number>) =>
  configWithFractions.reduce((acc, cur) => acc + cur, 0);

export const componentsHeightMapToCSSGridTemplateString = (
  fractionsMap: Map<keyof SingleValueComponent, string>,
) =>
  Array.from(fractionsMap)
    .map(([key, value]) => `"${key}" ${value}`)
    .join('\r\n');

export const getInnerGridValue = (
  innerContentMap: Map<keyof SingleValueComponent, number>,
  localFractionSum: number,
) => {
  const innerGridPercentValues = new Map<keyof SingleValueComponent, string>();
  let allAreasHeight = 0;

  innerContentMap.forEach((value, key) => {
    const areaHeight = Math.round((value / localFractionSum) * 100);
    allAreasHeight += areaHeight;
    const isRoundedOnePercentLeft = 100 - allAreasHeight === 1;
    innerGridPercentValues.set(
      key,
      `${isRoundedOnePercentLeft ? areaHeight + 1 : areaHeight}cqh`,
    );
  });
  return componentsHeightMapToCSSGridTemplateString(innerGridPercentValues);
};

const getOuterGridValue = (
  outerContentMap: Map<keyof SingleValueComponent, number>,
  fractionsSum: number,
) => {
  const outerGridPercentValues = new Map<keyof SingleValueComponent, string>();
  outerContentMap.forEach((value, key) =>
    outerGridPercentValues.set(
      key,
      `${Math.round((value / fractionsSum) * 100)}cqh`,
    ),
  );

  const valueHeight =
    100 - parseInt(outerGridPercentValues.get('label') ?? '0');

  outerGridPercentValues.set('content', `${Math.round(valueHeight)}cqh`);

  return componentsHeightMapToCSSGridTemplateString(outerGridPercentValues);
};

/**
 * Builds layout rows to divide the space for label, value and trend inside the ContentGrid
 *
 * @param hasLabel -
 * @param hasValue -
 * @param hasTrend -
 * @param hasSparkline -
 */
export function buildValueContentGridRows(
  hasLabel: boolean,
  hasValue: boolean,
  hasTrend: boolean,
  hasSparkline: boolean,
) {
  const innerComponents = new Map<keyof SingleValueComponent, number>();
  const outerComponents = new Map<keyof SingleValueComponent, number>();

  hasValue && innerComponents.set('value', fractions.value);
  hasTrend && innerComponents.set('trend', fractions.trend);
  hasSparkline && innerComponents.set('sparkline', fractions.sparkline);

  hasLabel && outerComponents.set('label', fractions.label);

  const innerComponentsFractionsArray = [...innerComponents.values()];

  const innerFractionSum = sumFractions(innerComponentsFractionsArray);
  const outerFractionSum = sumFractions([
    ...innerComponentsFractionsArray,
    ...outerComponents.values(),
  ]);

  return {
    innerGrid: getInnerGridValue(innerComponents, innerFractionSum),
    outerGrid: getOuterGridValue(outerComponents, outerFractionSum),
  };
}
